import script from "./BaseDragDrop.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDragDrop.vue?vue&type=script&setup=true&lang=js"

import "./BaseDragDrop.vue?vue&type=style&index=0&id=4bd63a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd63a04"]])

export default __exports__